import { render, staticRenderFns } from "./Door.vue?vue&type=template&id=7b47b668&scoped=true"
import script from "./Door.vue?vue&type=script&lang=ts"
export * from "./Door.vue?vue&type=script&lang=ts"
import style0 from "./Door.vue?vue&type=style&index=0&id=7b47b668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b47b668",
  null
  
)

export default component.exports